// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"4d26b4d5","100":"9e76ce0d","187":"ae2ff20b","295":"a4cdd082","647":"fc7574a0"}[chunkId] + ".chunk.css";
};